import MatchMedia from '@/js/core/MatchMedia'
import gsap from 'gsap'
import $ from 'jquery'

export default class MouseFollow extends MatchMedia {
  static root = '[data-mouse-follow]'

  selectors = {
    'target': '[data-mouse-follow-target]',
    'trigger': '[data-mouse-follow-trigger]',
  }
  
  actions = {
    breakpointSMMatches: 'update'
  }

  move ({ pageX, pageY }) {
    const offset = this.$.trigger.offset()
    const height = this.$.trigger.height()
    const width = this.$.trigger.width()
    const x = pageX - (offset.left + width - 90)
    const y = pageY - (offset.top + height / 2 + 90)
    gsap.to(this.$els.target, { x, y, duration: 1, ease: 'expo.out' })

    if (pageX < offset.left || pageX > offset.left + width || 
        pageY < offset.top || pageY > offset.top + height) {
      this.reset()
    }
  }

  follow () {
    this.$.trigger.on('mousemove', this.move.bind(this))
  }
  
  reset () {
    this.$.trigger.off('mousemove')
    gsap.to(this.$els.target, { x: 180 * .7, y: -180, duration: 1, ease: 'expo.out', clearProps: 'all' })
  }

  addListeners () {
    this.$.trigger.on('mouseenter', this.follow.bind(this))
    this.$.trigger.on('mouseleave', this.reset.bind(this))
  }

  removeListeners () {
    this.$.trigger.off('mouseenter')
    this.$.trigger.off('mouseleave')
  }

  update () {
    const { breakpointSMMatches } = this.state
    
    if (breakpointSMMatches === undefined) return

    if (breakpointSMMatches) {
      this.removeListeners()
      return 
    }

    if (!$.device.mobile)
      this.addListeners()
  }
}